import { lastValueFrom } from 'rxjs';
import { ApValidationService } from './services/validacionAP.service';
import { Component, AfterViewInit, ViewChild, ElementRef, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '@services/theme.service';
import { LoaderService } from '@services/loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit {

  @ViewChild('main') mainLayout!: ElementRef;

  theme!: any;
  title!: string;
  selectedLang!: string;
  initialized = false;
  currentLanguage = '';
  isLoading$: Observable<boolean>;

  constructor(
    private translate: TranslateService,
    private themeService: ThemeService,
    private router: Router,
    private apValidationService: ApValidationService,
    private loaderService: LoaderService
    ) {
      this.isLoading$ = this.loaderService.loading$;
    }

  ngOnInit(): void {
    this.setInitialTheme();
    this.setNavigatorLanguage();
    this.themeService.getCurrentTheme().subscribe(theme => {
      this.theme = theme;
      this.title = theme.name;
      this.selectedLang = this.theme.header.lang.default;
      this.translate.addLangs(['es', 'en', 'ca', 'fr'].map(t => this.title.toLowerCase() + '-' + t));
      this.translate.setDefaultLang(this.title.toLowerCase() + '-' + this.currentLanguage);
      localStorage.setItem('lang', this.currentLanguage);
      const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = `${window.location.origin}/${this.theme.favico}`;
      document.getElementsByTagName('head')[0].appendChild(link);
      if (this.initialized) {
        this.mainLayout.nativeElement.style.backgroundImage = `url("${this.theme.bg}")`;
        this.mainLayout.nativeElement.style.fontFamily = 'DM Sans,sans-serif';
      }
    });
    this.getAp();
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    this.mainLayout.nativeElement.style.backgroundImage = `url("${this.theme.bg}")`;
    this.mainLayout.nativeElement.style.fontFamily = 'DM Sans,sans-serif';
  }

  setInitialTheme() {
    const splitedRoute = window.location.href.split('guest/s/');
    if (splitedRoute.length === 1) {
      this.themeService.setTheme(environment.themes.grandValira);
      return;
    }

    const splitedSite = splitedRoute[1].split(/\/(.*)/s);
    localStorage.setItem('site', splitedSite[0])

    const splitedParams = Object.fromEntries(splitedSite[1].split('&').map(p => p.split('=')));


    if (splitedParams.ap || splitedParams['?ap']) {
      localStorage.setItem('ap', splitedParams.ap || splitedParams['?ap'])
    }

    if (splitedParams.id) {
      localStorage.setItem('id', splitedParams.id)
    }

    if (splitedParams.t) {
      localStorage.setItem('t', splitedParams.t)
    }

    if (splitedParams.url) {
      localStorage.setItem('url', splitedParams.url)
    }

    if (splitedParams.ssid) {
      localStorage.setItem('ssid', splitedParams.ssid)
    }

    //   // [1] guest = Fixed part of the route and never change. :white_check_mark:
    //   // [2] s = Fixed part of the route and never change. :white_check_mark:
    //   // [3] bls1mrgk = Site :white_check_mark:
    //   // [4] ap=18:e8:29:fa:a4:fa = MAC adress of the access point the user is attempting to connect from (helps speed up API Auth call) :white_check_mark:
    //   // [5] id=22:32:6c:f8:a7:c8 = MAC address of the user's devices :white_check_mark:
    //   // [6] t=1585317155 = Unix timestamp of the redirect :white_check_mark:
    //   // [7] url=http://example.com = The original URL requested by the client :white_check_mark:
    //   // [8] ssid=dev-net-old = WLAN that the user is attempting to connect to :white_check_mark:
    //   // Thanks to @slooffmasterfor the help!

    // GV         ENSISA: ibw4pc32
    // Ordino     SECNOA: 9egdutek
    // Palarinsal SAETDE: j70tm5sb
    const themes: any = {};

    ///DEV
    //no gratis
    themes['ibw4pc32'] = 'grandValira';
    themes['9egdutek'] = 'ordino';
    themes['j70tm5sb'] = 'palarinsal';
    //gratis
    themes['wiw3jcz4'] = 'grandValira';
    themes['hfodgnfb'] = 'ordino';
    themes['7sfaakdg'] = 'palarinsal';


    ///PRO
    //no gratis
    themes['4ss95kdd'] = 'grandValira';
    themes['5jg2u9ep'] = 'ordino';
    themes['2nga8v9q'] = 'palarinsal';
    themes['s8fbp53r'] = 'grandValira';
    //gratis
    themes['r1e2p5us'] = 'grandValira';
    themes['nr575i87'] = 'ordino';
    themes['cvjklkvs'] = 'palarinsal';
    themes['8xb5cvjy'] = 'grandValira';

    this.themeService.setTheme((environment.themes as any)[themes[splitedSite[0]]] || (environment.themes as any)['grandValira']);
  }

  async getAp(){
    const apParams = {
      ap: localStorage.getItem('ap'),
      site: localStorage.getItem('site')
    }
    try {
      const apValidation = await lastValueFrom(this.apValidationService.apValidation(apParams));
      if (apValidation.msg === 'OK') {
        localStorage.setItem('freeUrl', apValidation.response.freeWifiUrl);
        localStorage.setItem('okUrl', apValidation.response.wifiUrl);
        localStorage.setItem('url', apValidation.response.url);
        localStorage.setItem('wantContest', apValidation.response.contest ? 'si' : 'no')
        if (apValidation.response.free === true) {
          this.router.navigateByUrl('freeWifi');
        } else {
          this.router.navigateByUrl('email');
        }
      }
    } catch (error: any){
      this.router.navigateByUrl('outRange');
    }
  }

  setNavigatorLanguage() {
    switch (navigator.language.substring(0, 2)) {
    case 'es':
      this.currentLanguage = 'es'
    break;
    case 'en':
      this.currentLanguage = 'en'
    break
    case 'fr':
      this.currentLanguage = 'fr'
    break
    case 'ca':
      this.currentLanguage = 'ca'
    break
    default:
      this.currentLanguage = 'en'
    }
  }

}
